import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import WidgetCard from './WidgetCard';
import MainCardTitle from './MainCardTitle';
import CenteredSpinner from '../../../components/CenteredSpinner';
import DashboardServices from '../../../services/DashboardServices';
import localStorageService from '../../../services/localStorageService';

const CasesByBranchStatus = ({ title = "Ongoing and resolved cases by Branch" }) => {
    const [loading, setLoading] = useState(true);
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        let mounted = true;
        const load = async () => {
            setLoading(true);
            try {
                // Get params with organization_id if applicable
                const storedUser = localStorageService?.getItem?.('user') ?? null;
                const roles = (storedUser?.roles) || (storedUser?.role) || storedUser?.rolesArray || [];
                const normalizedRoles = Array.isArray(roles) ? roles.map(r => String(r).toLowerCase()) : [];
                const targetRoles = ['organization admin', 'case officer', 'case manager', 'organization head', 'director cid', 'director ncpa', 'deputy director','oic','department head','team leader first respondent','call center officer mowca', 'counselling officer', 'legal officer'];
                const hasTargetRole = normalizedRoles.some(r => targetRoles.includes(r));

                const params = {};
                
                if (hasTargetRole) {
                    const orgId = storedUser?.employee?.organization_id ?? storedUser?.organization_id ?? storedUser?.org?.id ?? null;
                    if (orgId) params.organization_id = orgId;
                }

                const res = await DashboardServices.getDashboardCasesByBranchStatus(params);
                const payload = res?.data ?? res;
                const dataArray = payload?.view?.data ?? payload?.data ?? payload ?? [];
                
                // Transform data for grouped bar chart
                const formatted = Array.isArray(dataArray) 
                    ? dataArray.map((item) => ({
                        name: item.branch_name ?? item.name ?? 'Unknown',
                        Ongoing: Number(item.ongoing_cases ?? item.ongoing) || 0,
                        Resolved: Number(item.resolved_cases ?? item.resolved) || 0,
                        branch_id: item.branch_id
                    }))
                    : [];

                console.log('Cases by Branch Status Data:', formatted);
                if (mounted) setChartData(formatted);
            } catch (err) {
                console.error('Failed to load cases by branch status data', err);
            } finally {
                if (mounted) setLoading(false);
            }
        };

        load();
        return () => { mounted = false; };
    }, []);

    //if (loading) return <WidgetCard><CenteredSpinner /></WidgetCard>;

    return (
        <WidgetCard>
            <MainCardTitle>{title}</MainCardTitle>

            {chartData.length === 0 ? (
                <Typography variant="body2" color="text.secondary" align="center" sx={{ py: 4 }}>
                    No data available
                </Typography>
            ) : (
                <Box sx={{ width: '100%', height: 400, mt: 2 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart 
                            data={chartData}
                            margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
                        >
                            <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
                            <XAxis 
                                dataKey="name" 
                                angle={0}
                                textAnchor="middle"
                                height={60}
                                tick={{ fill: '#666', fontSize: 12 }}
                            />
                            <YAxis 
                                tick={{ fill: '#666', fontSize: 12 }}
                                label={{ value: 'Cases', angle: -90, position: 'insideLeft', style: { fill: '#666' } }}
                            />
                            <Tooltip 
                                contentStyle={{ 
                                    backgroundColor: '#fff', 
                                    border: '1px solid #ccc',
                                    borderRadius: 4
                                }}
                                cursor={{ fill: 'rgba(0,0,0,0.05)' }}
                            />
                            <Legend 
                                wrapperStyle={{ paddingTop: '20px' }}
                                iconType="circle"
                            />
                            <Bar 
                                dataKey="Ongoing" 
                                fill="#5e87d4"
                                radius={[8, 8, 0, 0]}
                            />
                            <Bar 
                                dataKey="Resolved" 
                                fill="#7cb342"
                                radius={[8, 8, 0, 0]}
                            />
                        </BarChart>
                    </ResponsiveContainer>
                </Box>
            )}
        </WidgetCard>
    );
};

export default CasesByBranchStatus;
